import session from '@/utils/session'
import { V3StoreTokenReq, GetCafeInfoReq } from '@/api/user.js'
import { buildReturnUrl } from '@/utils/authContext'
const state = {
  cafe_info: null
}

//mutations
const mutations = {
  SET_CAFE_INFO(state, data) {
    state.cafe_info = data
  },
  CLEAR_CAFE_INFO(state) {
    state.cafe_info = null
  }
}

//actions
const actions = {
  A_get_cafe_info(context, cafe_id) {
    return new Promise((resolve, reject) => {
      GetCafeInfoReq(cafe_id)
        .then((res) => {
          context.commit('SET_CAFE_INFO', res.data)
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  A_get_store_token(context, payload) {
    let obj = {
      cafe_id: payload.cafe_id,
      redirect_uri: payload.redirect_uri,
      is_safe_device: session.get('is_trust')
    }
    
    return new Promise((resolve, reject) => {
      V3StoreTokenReq(obj)
        .then((res) => {
          window.location.assign(buildReturnUrl(obj.redirect_uri, {
            token: res.data.api_token,
            customer_id: session.get('customer_id'),
            is_trust: session.get('is_trust')
          }))
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

export default {
  //空间命名
  namespaced: true,
  state,
  mutations,
  actions
}
